import React from "react";
import { PageList } from "../components/pageList";
import { useTableSchema } from "../hooks/useTableSchema";
import { useFormSchema } from "../hooks/useFormSchema";

const Project = ({ title = "Project" }) => {
  const [getTableSchema] = useTableSchema();
  const [getFormSchema] = useFormSchema();

  return (
    <PageList
      title={title}
      apiEntity={"project"}
      tableSchema={getTableSchema("project")}
      formSchema={getFormSchema("project")}
      showImport={false}
      initSort={{ by: "code", order: "desc" }}
      searchByTextField={true}
      // stats={{
      //   component: ProjecPageStats,
      //   props: {
      //     mb: 35,

      //   },
      // }}
    />
  );
};

export default Project;
